var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembership0 = function SvgMembership0(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "96.295%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    x2: "96.295%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "0%",
    x2: "96.295%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0771AE",
    d: "M9 5v.127l-.155.043A4 4 0 0 0 6 9.001v21.79a4 4 0 0 0 4 4h21.79a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm1 2.001L31.79 7a2 2 0 0 1 2 2v21.791a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V9.001a2 2 0 0 1 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M23.961 9.383a1 1 0 0 1 .117 1.993l-.117.007h-8.358a1 1 0 0 1-.117-1.993l.117-.007z",
    transform: "translate(6 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M7.768 11.04v1h-2.59v-1z",
    transform: "rotate(45 3.438 21.283)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.574 8.389v4.765h-1V8.389z",
    transform: "rotate(45 6.039 20.514)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M23.961 18.383a1 1 0 0 1 .117 1.993l-.117.007h-8.358a1 1 0 0 1-.117-1.993l.117-.007z",
    transform: "translate(6 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M7.768 20.106v1h-2.59v-1z",
    transform: "rotate(45 3.438 30.349)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.575 17.455v4.765h-1v-4.765z",
    transform: "rotate(45 6.04 29.58)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0771AE",
    d: "M14.419 5.001h12.952v3.18a2 2 0 0 1-2 2h-8.952a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.884 27.383)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11,
    fill: "#F50A0A",
    rx: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.398 2.377c-.884 0-1.715.324-2.328.9l-1.07.97-1.055-.955a3.4 3.4 0 0 0-2.343-.915c-.885 0-1.717.326-2.341.915A3.01 3.01 0 0 0 3.289 5.5c0 .833.344 1.618.97 2.207a3.4 3.4 0 0 0 2.343.915A3.38 3.38 0 0 0 8.93 7.72L10 6.754l1.055.954c.625.59 1.458.915 2.343.915s1.716-.324 2.341-.915a3 3 0 0 0 .972-2.209c0-.835-.344-1.618-.97-2.209a3.4 3.4 0 0 0-2.343-.913m-5.81 4.052c-.527.497-1.445.497-1.972 0a1.27 1.27 0 0 1-.409-.929c0-.351.145-.68.41-.93.266-.25.62-.389.985-.386.372 0 .722.137 1 .399l1.014.918zm6.796 0c-.527.498-1.431.51-1.987-.013l-1.013-.918 1.027-.93c.528-.497 1.446-.497 1.973 0 .264.25.409.578.409.93 0 .351-.146.682-.41.931z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembership0);
export default ForwardRef;